import React, { useState, useEffect } from 'react';
import $ from "jquery";

import MenuItem from '../common/MenuItem';

const LeftSideNav = (props) => {

	const [flag, setFlag] = useState(false);
	const [isMobileMenu, setMobileMenu] = useState(false);

	useEffect(() => {
		window.addEventListener('resize', (event) => mobMenuInit());
	}, []);

	function mobMenuInit() {
		let ww = $(window).width();
		
		if (ww < 1054) {
			setFlag(true)
		} else {
			setFlag(false)
		}
	}

    return (
        <>
            <div 
				className={isMobileMenu ? "nav-button-wrap color-bg vismobmenu_btn" : "nav-button-wrap color-bg"} 
				onClick={() => setMobileMenu(!isMobileMenu)}
			>
			    <div className="nav-button">
			        <span /><span /><span />
			    </div>
			</div>
		    <div className={isMobileMenu ? "nav-holder main-menu vismobmenu" : "nav-holder main-menu"}>
				<nav className={(flag || isMobileMenu) ? "menusb" : ""}>
					<ul className="no-list-style">
                        <MenuItem link="/" text="Home" />
                        <MenuItem link="/write-a-review" text="Write a Review" />
                        <MenuItem link="/biz/home" text="Business" />
                        <MenuItem link="/people" text="People" />
					</ul>
				</nav>
			</div>
        </>
    );
};
export default LeftSideNav;